// English translations
export const en = {
    login: {
        title: "Login to YMS",
        emailLabel: "Email",
        emailPlaceholder: "Your email",
        passwordLabel: "Password",
        passwordPlaceholder: "Your password",
        submit: "Login",
        forgotPassword: "Forgot your password?",
        selectLanguage: "Select language",
        logoAlt: "YARD Logo",
        entersoftLogoAlt: "Entersoft Logo",
        requiredField: "Required field",
        needAccount: "Need an account?",
        signUpHere: "Sign Up here"
    },
    signUp: {
        title: "Sign Up to YMS",
        fullName: "Full Name",
        fullNamePlaceholder: "Full Name",
        email: "Email",
        emailPlaceholder: "Email",
        phone: "Phone",
        phonePlaceholder: "Phone",
        company: "Company",
        companyPlaceholder: "Company VAT",
        internalUser: "Internal User",
        requiredName: "Name is required.",
        requiredEmail: "Email is required.",
        invalidEmail: "Email format is invalid.",
        requiredCompany: "Company is required for external users."
    },
    profile: {
        title: "Profile",
        description: "Your personal information appears here.",
        logout: "Logout",
        userImageAlt: "User image",
        company: "Company",
        companyName: "Entersoftone",
        companyLogoAlt: "Company logo",
        aboutTitle: "About you",
        appearance: "Appearance",
        darkTheme: "Dark theme",
        lightTheme: "Light theme",
        colorSelection: "Color Selection",
        resetColor: "Reset color",
        themes: {
            title: "Themes",
            autumnSpice: "Autumn Spice",
            ocean: "Ocean",
            forest: "Forest",
            AberonYardTheme: "Aberon Yard",
            lavender: "Lavender",
            stopJiggle: "Stop Jiggle"
        },
        applySklavenitisColors: "Apply all Sklavenitis colors",
        resetAll: "Reset All",
        name: "Name",
        email: "Email",
        role: "Role",
        customStylesSaved: "Custom styles saved successfully!",
        clickToCustomize: "Click to customize colors"
    },
    warehouseModal: {
        title: "Warehouse Selection",
        description: "Select the distribution centers you want to serve for shipping your products.",
        cancel: "Cancel",
        continue: "Continue"
    },
    colors: {
        '--color-main-background': 'Main Color',
        '--color-secondary-background': 'Secondary Color',
        '--color-secondary-dark-background': 'Dark Secondary Color',
        '--color-shadow-background': 'Shadow',
        '--color-capacity-background': 'Capacity Color',
        '--color-capacity-full-background': 'Full Capacity Color'
    },
    noMatch: {
        title: 'Oh! The road leads nowhere!',
        description: 'Sorry, but the address you entered leads nowhere on this website.',
        goBack: 'Go back to home'
    },
    profileMenu: {
        userMenu: "User Menu",
        profile: "Profile",
        logout: "Logout",
        status: "Status",
        statusItems: {
            expected: "Expected",
            arrived: "Arrived",
            readyToLoad: "Ready to load",
            loading: "Loading...",
            finished: "Finished"
        },
        goodMorning: "Good morning",
        goodAfternoon: "Good afternoon",
        goodEvening: "Good evening"
    },
    passwordReset: {
        title: "Reset your password",
        emailLabel: "Email",
        emailPlaceholder: "Your email",
        successMessage: "An email has been sent to reset your password. Please wait for the administrator to contact you via email with instructions for the next steps."
    },
    pagination: {
        previous: "Previous",
        next: "Next",
        pageInfo: "Page {current} of {total}"
    },
    changePassword: {
        title: "Change Password",
        subtitle: "For your first login to Aberon YMS, please create the password you will use from now on.",
        newPasswordLabel: "New Password",
        newPasswordPlaceholder: "New password",
        confirmPasswordLabel: "Confirm Password",
        confirmPasswordPlaceholder: "Confirm password",
        passwordsMismatch: "Passwords don't match",
        backButton: "Back",
        successMessage: "Success! Your password has been changed successfully.",
        apiError: "The new password and confirmation password don't match.",
    },
    StatusDescr: {
        pending: "Pending",
        change: "Change",
        preliminarDetention: "Scheduled Booking",
        canceled: "Cancelled",
        accepted: "Accepted",
        expected: "Expected",
        arrived: "Arrived",
        readyToLoad: "Ready to load",
        loading: "Loading",
        finished: "Completed",
        default: "Not finalized"
    },
    StatusExample: {
        pending: 'The booking was created and is awaiting confirmation.',
        change: 'The booking was modified and awaits reconfirmation.',
        preliminarDetention: 'A scheduled or recurring booking.',
        canceled: 'The booking was canceled.',
        accepted: 'The booking was accepted and is active.',
        arrived: 'The vehicle has arrived at the warehouse yard.',
        loading: 'The vehicle is currently being loaded.',
        finished: 'The process completed successfully.',
        yard_expected: 'The vehicle is expected to arrive at the yard according to the booking.',
        yard_arrived: 'The vehicle has arrived at the yard and its arrival was recorded.',
        yard_readyToLoad: 'The vehicle is ready and waiting to start loading.',
        yard_loading: 'The vehicle is currently in the loading process.',
        yard_finished: 'Loading completed and the vehicle has left the yard.'
    },
    bookingCalendar: {
        days: "Days",
        week: "Week",
        deleteTitle: "Are you sure you want to delete this booking?",
        deleteDescr: "This action cannot be undone. ",
        acceptDelete: "Yes, delete",
        noWarehouseTitle: "No Warehouses Found",
        noWarehouseMessage: "It looks like you haven't configured any warehouses yet. Please contact your administrator or set one up to begin managing bookings.",
        goToCurrent: "Go to current date",
        full: "Full",
        free: "Free"
    },
    ModalBooking: {
        successTitleForBooking: "The booking was saved successfully",
        successSubTitleForBooking: "with BookingId",
        successSubTitleDetailsForBooking: "You can view or edit the booking from the calendar.",
        codeForEntry: "Entry code",
        createNewBookingTitle: "Create New Booking",
        createScheduledBookingTitle: "Create Scheduled Booking",
        selectOneSupplierWarning: "Please select one supplier first",
        editBookingTitle: "Edit Booking",
        stepBasicInfo: "Basic Information",
        stepActions: "Actions",
        quantitiesTitleForm: "Quantities",
        quantitiesPlaceholder: "Enter quantity",
        bookingFrequencyTitleForm: "Booking frequency",
        bookingFrequencyPlaceholder: "Enter frequency",
        posTitleForm: "Po's",
        posPlaceholder: "Select PO",
        supplierTitleForm: "Supplier",
        supplierPlaceholder: "Select Supplier",
        plPlaceholder: "Select 3PL",
        descrSupplierTitleForm: "Supplier Description",
        autoFilledField: "Auto-filled field",
        requiredFieldsCompleted: "required fields completed",
        allRequiredFieldsCompleted: "All required fields have been filled in!",
        dateTimeTitleForm: "Date and Time",
        driverTitleForm: "Driver",
        licenseNoTitleForm: "License Plate",
        phoneTitleForm: "Contact Phone",
        descrForBookingTitle: "Action Details",
        actionsHeader: "Actions",
        newTaskLabel: "New Task",
        taskLabel: "Task",
        categoryTitleForm: "Item Category",
        cargoTypeTitleForm: "Cargo Type",
        extraTaskTitleForm: "Extra Actions",
        itemCountTitleForm: "Item Count",
        palletCountTitleForm: "Pallets",
        addTaskButton: "Add Task",
        yardTaskType: 'Action Type',
        errorSavingBooking: 'An error occurred while saving the booking',
        successPreBooking: "Successful saving of a scheduled reservation!",
        minutes: "minutes",
        minutesCapitalized: "minutes",
        itemsShort: "c",
        palletsShort: "p",
        bookingSimple: "Booking",
        sumPallets: "Total number of pallets",
        sumItems: "Total number of items",
        categoryRequired: "Item category is required for all tasks",
        selectOnlyOneSupplier: "Please select only one Supplier",
        durationWillBeCalculated : "The duration will be calculated automatically based on the pallets and item count you added",
    },
    yardView: {
        unknown: "Unknown",
        driverDelay: "Driver delay",
        titleArrival: 'Arrival Info',
        semiTrailer: 'Semi-Trailer',
        loadDone: "Loading done",
        cancelLoading: "Cancel assignment",
        driverArrived: "Driver arrived",
        licensePlate: "License Plate",
        supplier: "Supplier",
        showLicense: "Show License Plate",
        showSupplier: "Show Supplier",
        errorNoTaskForDraggedTruck: "Could not find the corresponding task for the dragged truck",
        lastSMSSent: "Last SMS sent",
        errorNoPhoneForSms: "Phone number is missing. Cannot send SMS.",
        occupied: "Occupied",
        closed: "Closed",
        confirmLoadDoneTitle: "Confirm Completion",
        confirmLoadDoneMessage: "Are you sure you want to complete the loading?"
    },
    bookingFrequency: {
        title: "Recurrence Pattern",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        yearly: "Yearly",
        bookingTimeTitle: "Booking Time",
        startTime: "Start",
        duration: "Duration",
        repetitionPeriodTitle: "Repetition Period",
        repetitionStart: "Start",
        endsNever: "Never",
        endsAfter: "Ends after:",
        endsAfterTimes: "times",
        endsUntil: "Ends by:",
        recurrencePattern: "Recurrence Pattern",
        recurrencePeriod: "Recurrence Period",
        never: "Never",
        endAfter: "Ends after:",
        times: "times",
        endBy: "Ends by:",
        am: 'a.m.',
        pm: 'p.m.',
        time: 'Time'
    },
    listPos: {
        poCode: "PO's",
        supplier: "Supplier",
        dateTime: "Date & Time",
    },
    listSuppliers: {
        code: "Code",
        supplier: "Supplier",
        nameShort: "Abbreviation",
        vat: "VAT",
        clickToFetch: "Click the 'Load icon' to load data or use the search to find specific records."
    },
    list3pls: {
        code: "Code",
        description: "Description",
        socialSecurityNo: "VAT",
        clickToFetch: "Click the 'Load icon' to load data or use the search to find specific records."
    },
    contextMenu: {
        newBooking: "New Booking",
        scheduledBooking: "Scheduled Booking",
        editable: "Edit"
    },
    calendarEvent: {
        duration: "Booking Duration",
        ramp: "Ramp",
        plate: "Plate",
        driver: "Driver",
        phone: "Phone",
        noActions: "No actions allowed",
        noActionsAdded: "There are no actions.",
        withOutSupplier: "Without supplier",
        noEvents: "No Bookings found."
    },
    truckJourney: {
        loading: "Loading...",
        noZonesMessage: "No zones have been registered for this distribution center",
        noArrivalsMessage: "There are no arrival bookings",
        noParkingMessage: "There are no parking bookings",
        driverDelay: "Driver delay",
        name: "Name",
        unknown: "Unknown",
        licensePlate: "License plate",
        resendSMS: "Resend SMS",
        rampAssignment: "Ramp action assignment",
        loadingStatus: "Loading...",
        selectWarehouse: "Select Warehouse",
        selectTaskBeforeDrag: "Please select a task before dragging to ramp",
        allButton: "All Ramps",
        allZones: "All Zones"
    },
    tablet: {
        entry: "Entry",
        entryWithNoBooking: "Entry without booking",
        entryWithBooking: "Entry with booking",
        exit: "Vehicle exit",
        home: "Home",
        noTaskError: "You must add at least one task before saving.",
        noDriverError: "You must select a driver before saving.",
        noTruckError: "You must select a truck before saving.",
        qrNotActiveOrNotExist: "The QR code is either inactive or does not exist.",
        driver: "Driver",
        driverBan: "has a ban on entry. Please select another driver.",
        driverBanWarning: "Driver \"{{driverName}}\" has a ban on entry. Please select another driver.",
        cannotSaveWithBannedDriver: "You cannot save with a driver who has an entry ban. Please select another driver.",
        noBookingSelected: "Cannot save booking. Please select a booking.",
        noWarehouseTitle: "No Warehouse Assigned",
        noWarehouseMessage: "Please contact the administrator to assign you a warehouse."
    },
    entryWithBooking: {
        subtitle: "Do you have an entry code, supplier VAT number, or license plate?",
        qrLabel: "QR Code",
        qrPlaceholder: "Enter manually",
        scanQrButton: "Scan QR code",
        supplierLabel: "3PL/Supplier",
        supplierPlaceholder: "Enter the VAT of 3PL/Supplier",
        availableBookings: "Available Bookings",
        bookingId: "Booking ID",
        warehouse: "Warehouse",
        supplier: "Supplier",
        scanButton: "Scan",
        stampTitleForm: "Stamp",
        commentTitleForm: "Comment",
        successTitle: "Entry granted successfully",
        nextEntry: "Next entry",
        supplierTab: "Supplier",
        ownedCooperatingTab: "Owned/Cooperating",
        stampSection: "Stamp",
        stampNo: "No",
        stampElectronic: "Electronic",
        stampPlastic: "Plastic",
        plasticStampPlaceholder: "Record the stamp",
        genderSection: "Empty",
        genderNo: "No",
        genderYes: "Yes"
    },
    newWithBooking: {
        loadingTasks: "Loading actions",
        supplierVatTitleForm: "VAT Supplier",
        placeholderVatTitleForm: "Write the Vat",
        availableVats: "Available VAT",
    },
    exitBooking: {
        warningWithBookingAndVat: "No license plate found that matches any of the Bookings. Please check the license plate and try again.",
        pendingBookingWarning: "There are pending bookings that need to be completed."
    },
    photoUpload: {
        addPhotos: "Add photos",
        addMorePhotos: "Add more photos",
        openCamera: "Open camera",
        chooseFromLibrary: "Choose from library",
    },
    common: {
        loading: "Loading...",
        error: "Error",
        success: "Success",
        warning: "Warning",
        next: "Next",
        backButton: "Back",
        no: "No",
        resetButton: "Reset",
        changeButton: "Change",
        saveButton: "Save",
        prevButton: "Previous",
        select: "Select",
        choose: "Choose",
        registration: "Submit",
        noData: "No data found",
        add: "Add",
        accept: "Accept",
        acceptedSuccess: "Accepted Successfully!",
        cancelledSuccess: "Cancelled Successfully!",
        delete: "Delete",
        cancel: "Cancel",
        confirm: "Confirm",
        search: "Search",
        submit: "Sign Up",
        cancelled: "Cancelled",
        apply: "Apply",
        deselectAll: "Deselect All",
        totalRows: "Total Rows:",
        rowsPerPage: "Rows per page:",
        displayedRows: "{{from}}–{{to}} of {{count}}",
        moreThan: "more than {{to}}",
        rowSelected: "{{count}} row selected",
        rowsSelected: "{{count}} row(s) selected",
        requiredField: "Value is required for field",
        clear: "Clear",
        allCategories: "All Categories",
        selectOne: "Select",
        changesSaved: "Changes saved successfully!",
    },
    toolkit: {
        filterDesigner: "Queries",
        fieldChooser: "Field Chooser",
        exportExcel: "Export to Excel",
        table: 'Table',
        grid: 'Grid',
        dashboard: 'Dashboard',
        filterExpression: "Queries",
        fields: 'Fields'
    }
};
